export const SHOW_TOAST = '@toast/SHOW_TOAST';
export const HIDE_TOAST = '@toast/HIDE_TOAST';
